module.exports = __webpack_public_path__ + "196dc60dae2b6e07d93ab9363d4517b2.woff2";